import React, { PureComponent } from "react";
import FacebookIcon from "mdi-react/FacebookIcon";
import GooglePlusIcon from "mdi-react/GooglePlusIcon";
import LogInForm from "./LogInForm";
import AppConfig from "../../../../config/appconfig.json";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { GoogleLogin } from "react-google-login";
import {checkAgreement} from "./CheckAgreement";

export default class UserLogIn extends PureComponent {
  facebookResponse = response => {
    // console.log(response);
    if (response.email) {
      let isCheckEmailFailed = false;
      const request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Email: response.email
        })
      };
      fetch(`${AppConfig.BACK_END_URL}/APIClient/CheckEmail`, request)
        .then(response => {
          // console.log(response);
          if (response.ok === false) {
            isCheckEmailFailed = true;
          }
          return response.json();
        })
        .then(json => {
          if (isCheckEmailFailed) {
            const respObj = JSON.parse(json);
            console.log(respObj.Message);
            this.callCreateCustomerAPI(
              response.name,
              response.email,
              response.userID,
              true
            );
          } else {
            const respObj = JSON.parse(json);
            localStorage.setItem("kbeSid", respObj.Sid);
            localStorage.setItem("usernameLogin", response.name);
            localStorage.setItem("kbeEmail", response.email);
            // window.location.reload();
            checkAgreement(respObj.Sid);
          }
        })
        .catch(() => {
          console.log(
            "Something went wrong when checking email. Please try again."
          );
        });
    } else {
      console.log("No permission to read email");
    }
  };

  googleResponse = response => {
    // console.log(response);
    if (response.profileObj) {
      let isCheckEmailFailed = false;
      const request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Email: response.profileObj.email
        })
      };
      fetch(`${AppConfig.BACK_END_URL}/APIClient/CheckEmail`, request)
        .then(response => {
          // console.log(response);
          if (response.ok === false) {
            isCheckEmailFailed = true;
          }
          return response.json();
        })
        .then(json => {
          if (isCheckEmailFailed) {
            const respObj = JSON.parse(json);
            console.log(respObj.Message);
            this.callCreateCustomerAPI(
              response.profileObj.name,
              response.profileObj.email,
              response.profileObj.googleId,
              false
            );
          } else {
            const respObj = JSON.parse(json);
            localStorage.setItem("kbeSid", respObj.Sid);
            localStorage.setItem("usernameLogin", response.profileObj.name);
            localStorage.setItem("kbeEmail", response.profileObj.email);
            // window.location.reload();
            checkAgreement(respObj.Sid);
          }
        })
        .catch(() => {
          console.log(
            "Something went wrong when checking email. Please try again."
          );
        });
    }
  };

  googleErrorResponse = error => {
    console.log(error);
  };

  callCreateCustomerAPI(fullname, email, socialUserId, isFB) {
    let isCreateCustomerFailed = false;
    let request = null;
    if (isFB) {
      request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Email: email,
          Name: fullname,
          FB_ID: socialUserId,
          Username: email
        })
      };
    } else {
      request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Email: email,
          Name: fullname,
          Google_ID: socialUserId,
          Username: email
        })
      };
    }
    fetch(`${AppConfig.BACK_END_URL}/APIClient/CreateCustomer`, request)
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          isCreateCustomerFailed = true;
        }
        return response.json();
      })
      .then(json => {
        // console.log(json);
        if (isCreateCustomerFailed) {
          const respObj = JSON.parse(json);
          console.log(respObj.Message);
        } else {
          const respObj = JSON.parse(json);
          // console.log(respObj);
          localStorage.setItem("usernameLogin", respObj.Name);
          localStorage.setItem("kbeEmail", respObj.Email);
          localStorage.setItem("kbeSid", respObj.Sid);
          // window.location.reload();
          checkAgreement(respObj.Sid);
        }
      })
      .catch(() => {
        console.log(
          "Something went wrong when creating customer. Please try again."
        );
      });
  }

  render() {
    return (
      <div>
        <LogInForm onSubmit />
        <div className="account__or">
          <p>Or Easily Using</p>
        </div>
        <div className="account__social">
          <FacebookLogin
            appId={AppConfig.FACEBOOK_APP_ID}
            buttonText="Login"
            autoLoad={false}
            fields="name,email"
            scope="public_profile,email"
            callback={this.facebookResponse}
            redirectUri={AppConfig.FACEBOOK_REDIRECT_URI}
            version={AppConfig.FACEBOOK_API_VERSION}
            render={renderProps => (
              <button
                className="account__social-btn account__social-btn--facebook"
                onClick={renderProps.onClick}
              >
                <FacebookIcon />
              </button>
            )}
          />
          <GoogleLogin
            clientId={AppConfig.GOOGLE_APP_ID}
            buttonText="Login Google"
            responseType="id_token"
            autoLoad={false}
            onSuccess={this.googleResponse}
            onFailure={this.googleErrorResponse}
            className="account__social-btn account__social-btn--google"
            style={{}}
          >
            <GooglePlusIcon />
          </GoogleLogin>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/log_in/components/UserLogIn.js